import { RecoilRoot } from "recoil";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import { GlobalStyles } from "./style/GlobalStyles";

import Main from "./page/main/Main";
import Header from "./components/Header";
import Toast from "./components/Toast";
import Issues from "./page/issues/Issues";

function App() {
	return (
		<RecoilRoot>
			<BrowserRouter>
				<GlobalStyles />
				<Toast />
				<Header />

				<Routes>
					<Route path="/" element={<Main />}></Route>
					<Route path="/issues" element={<Issues />}></Route>
				</Routes>
			</BrowserRouter>
		</RecoilRoot>
	);
}

export default App;
